import _classCallCheck from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import React from 'react';
import { withStyles } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import Search from '@material-ui/icons/Search';
import Clear from '@material-ui/icons/Clear';
import InputBase from '@material-ui/core/InputBase';
import classNames from 'classnames';
import PropTypes from 'prop-types';

var styles = function styles(theme) {
  return {
    boundingBox: {
      display: 'inline-flex',
      borderRadius: '2px',
      //boxShadow: '0 2px 4px 0 rgba(0,0,0,0.5)',
      backgroundColor: '#F6F6F8',
      height: '36px'
    },
    searchIcon: {
      color: theme.palette.secondary.main,
      height: '36px',
      width: '36px'
    },
    clearIcon: {
      marginLeft: '8px'
    },
    iconButton: {
      paddingTop: '12px',
      height: '36px',
      width: '36px'
    }
  };
};

var SearchInput =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SearchInput, _React$Component);

  function SearchInput() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, SearchInput);

    var _temp;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(SearchInput)).call.apply(_getPrototypeOf2, [this].concat(args))), _this.state = {
      text: ''
    }, _this.handleChange = function (event) {
      var _this$props = _this.props,
          onTextChange = _this$props.onTextChange,
          searchLive = _this$props.searchLive;
      var newText = event.target.value;

      _this.setState({
        text: newText
      });

      if (onTextChange !== undefined && searchLive) {
        onTextChange(newText);
      }
    }, _this.handleClear = function () {
      var onTextChange = _this.props.onTextChange;
      var oldText = _this.state.text;
      var newText = '';

      _this.setState({
        text: newText
      });

      onTextChange(newText, oldText);
    }, _this.handleFind = function () {
      var onTextChange = _this.props.onTextChange;
      if (onTextChange !== undefined) onTextChange(_this.state.text);
    }, _this.handleKeyPress = function (e) {
      if (e.key === 'Enter') {
        _this.handleFind();
      }
    }, _temp));
  }

  _createClass(SearchInput, [{
    key: "render",
    value: function render() {
      // actions needs to be a list of actions
      // { label: 'actionLabel', isEnabled: () => {}, actionCallback: () => {}}
      var _this$props2 = this.props,
          classes = _this$props2.classes,
          width = _this$props2.width,
          placeholder = _this$props2.placeholder;
      return React.createElement('div', {
        className: classes.boundingBox
      }, React.createElement(IconButton, {
        className: classNames(classes.iconButton, classes.searchIcon),
        onClick: this.handleFind
      }, React.createElement(Search, null)), React.createElement(InputBase, {
        id: 'search-field',
        value: this.state.text,
        onChange: this.handleChange,
        onKeyPress: this.handleKeyPress,
        style: _extends({}, width !== undefined ? {
          width: width
        } : {}),
        placeholder: placeholder
      }), React.createElement(IconButton, {
        disabled: !(this.state.text && this.state.text !== ''),
        className: classNames(classes.iconButton, classes.clearIcon),
        onClick: this.handleClear
      }, this.state.text && this.state.text !== '' && React.createElement(Clear, null)));
    }
  }]);

  return SearchInput;
}(React.Component);

;
SearchInput.propTypes = {
  onTextChange: PropTypes.func,
  searchLive: PropTypes.bool,
  placeholder: PropTypes.string
};
export default withStyles(styles)(SearchInput);